let localFileIdSequence = 0;

/**
 * Id для файла, который ещё не отправлен на сервер.
 *
 * Такие файлы лежат в одних списках с серверными и сравниваются по id,
 * поэтому последовательность убывающая и отрицательная: она не сталкивается
 * ни сама с собой, ни с идентификаторами из базы.
 */
export const createLocalFileId = (): number => {
    localFileIdSequence += 1;
    return -localFileIdSequence;
};
